module.exports = __webpack_public_path__ + "LatoLatin-Light.f7b5d804f74da32f3500.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Light.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Light.ttf
// module chunks = styles